export const FEATURE_NAME = 'chartCustomizationSettings';
export const NEW_CHARTS_DEFAULT_FIELD_ID = 'orion.muzeChartPhase1EnabledGA';
export var TranslationKeys;
(function (TranslationKeys) {
    TranslationKeys["LOAD_FAILURE_MESSAGE"] = "tscli.ui.setting.get.failure.message";
    TranslationKeys["SAVE_FAILURE_MESSAGE"] = "tscli.ui.datasave.failure.message";
    TranslationKeys["SAVE_SUCCESS_MESSAGE"] = "adminSection.chartCustomization.settings.saveSuccess";
    TranslationKeys["NEW_CHARTS_DEFAULT_LABEL"] = "adminSection.chartCustomization.settings.newChartsDefault.label";
    TranslationKeys["SETTINGS_HEADER"] = "adminSection.chartCustomization.settings.header";
    TranslationKeys["EDIT_ACTION"] = "adminSection.chartCustomization.settings.editAction";
    TranslationKeys["SAVE_ACTION"] = "adminSection.chartCustomization.settings.saveAction";
    TranslationKeys["CANCEL_ACTION"] = "adminSection.chartCustomization.settings.cancelAction";
    TranslationKeys["ENABLED_LABEL"] = "tscli.ui.enabled.label";
    TranslationKeys["DISABLED_LABEL"] = "tscli.ui.disabled.label";
})(TranslationKeys || (TranslationKeys = {}));
//# sourceMappingURL=settings.constants.js.map